import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../components/Utilities';
import { route } from '../Util';

function Header({
  app,
  search,
  success,
  error,
}) {
  let alert;
  let alertBar;
  const handleToggle = () => {
    const newState = !window.sidebarIsActive;
    window.toggleSidebar(newState);
  };

  if (success) {
    alert = <div className="alert alert-success mb-0" style={{ borderRadius: 0 }}>{success}</div>;
  } else if (error) {
    alert = <div className="alert alert-danger mb-0" style={{ borderRadius: 0 }}>{error}</div>;
  }

  if (alert) {
    alertBar = (
      <div className="row">
        <div className="col-md-12">
          {alert}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="app-header row">
        <div className="d-none d-md-block col-md-6">
          <a className={`app-link people ${app === 'people' ? 'active' : ''}`} href={route.people()}>
            <Icon icon="users" variant="fad" />
            {' '}
            People
          </a>
          <a className={`app-link projects ${app === 'projects' ? 'active' : ''}`} href={route.projects()}>
            <Icon icon="tasks-alt" variant="fad" />
            {' '}
            Projects
          </a>
          <a className={`app-link techops ${app === 'techops' ? 'active' : ''}`} href={route.techops()}>
            <Icon icon="cogs" variant="fad" />
            {' '}
            TechOps
          </a>
          <a className={`app-link developers ${app === 'developers' ? 'active' : ''}`} target="_blank" href="https://developers.g4m.co.uk/" rel="noreferrer">
            <Icon icon="brackets-curly" variant="fad" />
            {' '}
            Developers
          </a>
        </div>
        {search && search.length > 1 && (
          search.map((searchItem, index) => (
            <div key={index} className="col-md-4 col-lg-3 col-6 ml-auto">
              {searchItem}
            </div>
          ))
        )}
        {/*  Else if it's not an array */}
        {search && (!search.length) && (
          <div className="col-md-6 col-lg-4 col-10 ml-auto">
            {search}
          </div>
        )}

        <div className="col-sm-2 col-2 d-md-none">
          <button type="button" className="btn sidebar-toggle" onClick={handleToggle}><Icon icon="bars" size="lg" /></button>
        </div>
      </div>
      {alertBar}
    </>
  );
}

Header.propTypes = {
  app: PropTypes.string,
  search: PropTypes.node || PropTypes.arrayOf(PropTypes.node),
  success: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Header.defaultProps = {
  app: undefined,
  search: null,
  success: null,
  error: null,
};

export default Header;
